const requestJson = async (path, options = {}) => {
  const response = await fetch(path, {
    credentials: "include",
    cache: "no-store",
    ...options,
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.headers || {}),
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.error || "The private admin request failed.");
    error.status = response.status;
    error.body = payload;
    throw error;
  }
  return payload;
};

export const getAdminSession = () => requestJson("/api/admin/session");

export const claimAdminOwner = () =>
  requestJson("/api/admin/bootstrap", {
    method: "POST",
    body: JSON.stringify({}),
  });

export const listAdminParticipants = ({
  query = "",
  sort = "accountCreatedAt",
  direction = "desc",
  limit = 250,
} = {}) => {
  const params = new URLSearchParams({
    sort,
    direction,
    limit: String(limit),
  });
  if (query.trim()) params.set("q", query.trim());
  return requestJson(`/api/admin/participants?${params.toString()}`);
};

export const getAdminParticipant = (userId) =>
  requestJson(`/api/admin/participants/${encodeURIComponent(userId)}`);

export const explainIntelligenceInsight = (payload) =>
  requestJson("/api/admin/intelligence/explain", {
    method: "POST",
    body: JSON.stringify({ payload }),
  });
